import React from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { Box } from "@mui/material";
import {
  RocketLaunchOutlined as RocketIcon,
  FilterAltOffOutlined as ResetFilterIcon,
} from "@mui/icons-material";
import { Path } from "../../../../../static/Constants";
import { NoData, CommonButton } from "../../../../Components/ui";

const AllMissileEmptyState = ({ onReset, onRefresh, hasActiveFilters }) => {
  const history = useHistory();

  if (hasActiveFilters) {
    return (
      <Box sx={{ my: 3 }}>
        <NoData
          title="No Matching Missile Lotteries"
          subtitle="No rocket lotteries match your current search criteria. Try adjusting or clearing your search query."
          icon={<RocketIcon sx={{ fontSize: 32 }} />}
          action={
            <CommonButton
              variant="primary"
              size="small"
              onClick={onReset}
              startIcon={<ResetFilterIcon />}
              sx={{ px: 3 }}
            >
              Reset Filters
            </CommonButton>
          }
          paper={true}
          minHeight={280}
        />
      </Box>
    );
  }

  return (
    <Box sx={{ my: 3 }}>
      <NoData
        title="No Active Lotteries !"
        subtitle="There are currently no live rocket lotteries deployed on-chain. Explore our other exciting live lottery arenas!"
        icon={<RocketIcon sx={{ fontSize: 32 }} />}
        actionText="Explore All Lotteries"
        onAction={() => history.push(Path.allLotteries)}
        paper={true}
        minHeight={280}
      />
    </Box>
  );
};

AllMissileEmptyState.propTypes = {
  onReset: PropTypes.func.isRequired,
  onRefresh: PropTypes.func,
  hasActiveFilters: PropTypes.bool,
};

export default AllMissileEmptyState;
